/*===========================
##########MAIN MENU##########

=====PLUGINS=====    
	#Bootstrap Input Spinner --- Documentation ---  https://shaack.com/projekte/bootstrap-input-spinner/
    	-bootstrap-input-spinner.js
        -custom-editors.js
        
=====CUSTOM JS=====        
	#Global Javascript
    	-Bootstrap Input Spinner Implementation
    #Bootstrap Tooltips
    #LazyLoad
    #Hamburger Menu Icon
    #Site Navigation
    #Cart Drawer
    #Hero
    #Product Page
    	- Variant Selection Code
	#Select Callback
    	-Variables
        -Adjust Pure Number To Money Format
        -Product Page Changes
	#FAQ Page
    #Product Recommendations
    #Variant Out Of Stock Manager
    
=====SLIDERS=====
	#Product Item Card Slider
    #Product Image Slider
    
    

===========================*/

/*###############
	#PLUGINS
###############*/

/*===============================
	#Bootstrap Input Spinner
==============================*/

/*=====bootstrap-input-spinner.js=====*/

/**
 * Author and copyright: Stefan Haack (https://shaack.com)
 * Repository: https://github.com/shaack/bootstrap-input-spinner
 * License: MIT, see file 'LICENSE'
 */

/*=====FIXES=====*/
$(document).ready(function () {
  $(".form-control").attr("aria-label", "Quantity Input");
});

(function ($) {
  "use strict";

  // the default editor for parsing and rendering
  var I18nEditor = function (props, element) {
    var locale = props.locale || "en-US";

    this.parse = function (customFormat) {
      var numberFormat = new Intl.NumberFormat(locale);
      var thousandSeparator =
        numberFormat.format(11111).replace(/1/g, "") || ".";
      var decimalSeparator = numberFormat.format(1.1).replace(/1/g, "");
      return parseFloat(
        customFormat
          .replace(new RegExp(" ", "g"), "")
          .replace(new RegExp("\\" + thousandSeparator, "g"), "")
          .replace(new RegExp("\\" + decimalSeparator), ".")
      );
    };

    this.render = function (number) {
      var decimals = parseInt(element.getAttribute("data-decimals")) || 0;
      var digitGrouping = !(
        element.getAttribute("data-digit-grouping") === "false"
      );
      var numberFormat = new Intl.NumberFormat(locale, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
        useGrouping: digitGrouping,
      });
      return numberFormat.format(number);
    };
  };

  var triggerKeyPressed = false;
  var originalVal = $.fn.val;
  $.fn.val = function (value) {
    if (arguments.length >= 1) {
      for (var i = 0; i < this.length; i++) {
        if (this[i]["bootstrap-input-spinner"] && this[i].setValue) {
          this[i].setValue(value);
        }
      }
    }
    return originalVal.apply(this, arguments);
  };

  $.fn.inputSpinner = function (methodOrProps) {
    if (methodOrProps === "destroy") {
      this.each(function () {
        if (this["bootstrap-input-spinner"]) {
          this.destroyInputSpinner();
        } else {
          console.warn("element", this, "is no bootstrap-input-spinner");
        }
      });
      return this;
    }

    var props = {
      decrementButton: "<strong>&minus;</strong>", // button text
      incrementButton: "<strong>&plus;</strong>", // ..
      groupClass: "", // css class of the resulting input-group
      buttonsClass: "btn-outline-secondary",
      buttonsWidth: "2.5rem",
      textAlign: "center", // alignment of the entered number
      autoDelay: 500, // ms threshold before auto value change
      autoInterval: 50, // speed of auto value change, set to `undefined` to disable auto-change
      buttonsOnly: false, // set this `true` to disable the possibility to enter or paste the number via keyboard
      keyboardStepping: true, // set this to `false` to disallow the use of the up and down arrow keys to step
      locale: navigator.language, // the locale, per default detected automatically from the browser
      editor: I18nEditor, // the editor (parsing and rendering of the input)
      // the template of the input
      template:
        '<div class="input-group ${groupClass}">' +
        '<button style="min-width: ${buttonsWidth}" class="btn btn-decrement ${buttonsClass} btn-minus" type="button">${decrementButton}</button>' +
        '<input type="text" inputmode="decimal" style="text-align: ${textAlign}" class="form-control form-control-text-input"/>' +
        '<button style="min-width: ${buttonsWidth}" class="btn btn-increment ${buttonsClass} btn-plus" type="button">${incrementButton}</button>' +
        "</div>",
    };

    for (var option in methodOrProps) {
      // noinspection JSUnfilteredForInLoop
      props[option] = methodOrProps[option];
    }

    var html = props.template
      .replace(/\${groupClass}/g, props.groupClass)
      .replace(/\${buttonsWidth}/g, props.buttonsWidth)
      .replace(/\${buttonsClass}/g, props.buttonsClass)
      .replace(/\${decrementButton}/g, props.decrementButton)
      .replace(/\${incrementButton}/g, props.incrementButton)
      .replace(/\${textAlign}/g, props.textAlign);

    this.each(function () {
      if (this["bootstrap-input-spinner"]) {
        console.warn("element", this, "is already a bootstrap-input-spinner");
      } else {
        var $original = $(this);
        $original[0]["bootstrap-input-spinner"] = true;
        $original.hide();
        $original[0].inputSpinnerEditor = new props.editor(props, this);

        var autoDelayHandler = null;
        var autoIntervalHandler = null;

        var $inputGroup = $(html);
        var $buttonDecrement = $inputGroup.find(".btn-decrement");
        var $buttonIncrement = $inputGroup.find(".btn-increment");
        var $input = $inputGroup.find("input");
        var $label = $("label[for='" + $original.attr("id") + "']");
        if (!$label[0]) {
          $label = $original.closest("label");
        }

        var min = null;
        var max = null;
        var step = null;

        updateAttributes();

        var value = parseFloat($original[0].value);
        var pointerState = false;

        var prefix = $original.attr("data-prefix") || "";
        var suffix = $original.attr("data-suffix") || "";

        if (prefix) {
          var prefixElement = $(
            '<span class="input-group-text">' + prefix + "</span>"
          );
          $inputGroup.find("input").before(prefixElement);
        }
        if (suffix) {
          var suffixElement = $(
            '<span class="input-group-text">' + suffix + "</span>"
          );
          $inputGroup.find("input").after(suffixElement);
        }

        $original[0].setValue = function (newValue) {
          setValue(newValue);
        };
        $original[0].destroyInputSpinner = function () {
          destroy();
        };

        var observer = new MutationObserver(function () {
          updateAttributes();
          setValue(value, true);
        });
        observer.observe($original[0], { attributes: true });

        $original.after($inputGroup);

        setValue(value);

        $input
          .on("paste input change focusout", function (event) {
            var newValue = $input[0].value;
            var focusOut = event.type === "focusout";
            newValue = $original[0].inputSpinnerEditor.parse(newValue);
            setValue(newValue, focusOut);
            dispatchEvent($original, event.type);
          })
          .on("keydown", function (event) {
            if (props.keyboardStepping) {
              if (event.which === 38) {
                // up arrow pressed
                event.preventDefault();
                if (!$buttonDecrement.prop("disabled")) {
                  stepHandling(step);
                }
              } else if (event.which === 40) {
                // down arrow pressed
                event.preventDefault();
                if (!$buttonIncrement.prop("disabled")) {
                  stepHandling(-step);
                }
              }
            }
          })
          .on("keyup", function (event) {
            // up/down arrow released
            if (
              props.keyboardStepping &&
              (event.which === 38 || event.which === 40)
            ) {
              event.preventDefault();
              resetTimer();
            }
          });

        // decrement button
        onPointerDown($buttonDecrement[0], function () {
          if (!$buttonDecrement.prop("disabled")) {
            pointerState = true;
            stepHandling(-step);
          }
        });
        // increment button
        onPointerDown($buttonIncrement[0], function () {
          if (!$buttonIncrement.prop("disabled")) {
            pointerState = true;
            stepHandling(step);
          }
        });
        onPointerUp(document.body, function () {
          if (pointerState === true) {
            resetTimer();
            dispatchEvent($original, "change");
            pointerState = false;
          }
        });
      }

      function setValue(newValue, updateInput) {
        if (updateInput === undefined) {
          updateInput = true;
        }
        if (isNaN(newValue) || newValue === "") {
          $original[0].value = "";
          if (updateInput) {
            $input[0].value = "";
          }
          value = NaN;
        } else {
          newValue = parseFloat(newValue);
          newValue = Math.min(Math.max(newValue, min), max);
          $original[0].value = newValue;
          if (updateInput) {
            $input[0].value = $original[0].inputSpinnerEditor.render(newValue);
          }
          value = newValue;
        }
      }

      function destroy() {
        $original.prop("required", $input.prop("required"));
        observer.disconnect();
        resetTimer();
        $input.off("paste input change focusout");
        $inputGroup.remove();
        $original.show();
        $original[0]["bootstrap-input-spinner"] = undefined;
        if ($label[0]) {
          $label.attr("for", $original.attr("id"));
        }
      }

      function dispatchEvent($element, type) {
        if (type) {
          setTimeout(function () {
            var event;
            if (typeof Event === "function") {
              event = new Event(type, { bubbles: true });
            } else {
              // IE
              event = document.createEvent("Event");
              event.initEvent(type, true, true);
            }
            $element[0].dispatchEvent(event);
          });
        }
      }

      function stepHandling(step) {
        calcStep(step);
        resetTimer();
        if (props.autoInterval !== undefined) {
          autoDelayHandler = setTimeout(function () {
            autoIntervalHandler = setInterval(function () {
              calcStep(step);
            }, props.autoInterval);
          }, props.autoDelay);
        }
      }

      function calcStep(step) {
        if (isNaN(value)) {
          value = 0;
        }
        setValue(Math.round(value / step) * step + step);
        dispatchEvent($original, "input");
      }

      function resetTimer() {
        clearTimeout(autoDelayHandler);
        clearTimeout(autoIntervalHandler);
      }

      function updateAttributes() {
        // copy properties from original to the new input
        if ($original.prop("required")) {
          $input.prop("required", $original.prop("required"));
          $original.removeAttr("required");
        }
        $input.prop("placeholder", $original.prop("placeholder"));
        $input.attr("inputmode", $original.attr("inputmode") || "decimal");
        var disabled = $original.prop("disabled");
        var readonly = $original.prop("readonly");
        $input.prop("disabled", disabled);
        $input.prop("readonly", readonly || props.buttonsOnly);
        $buttonIncrement.prop("disabled", disabled || readonly);
        $buttonDecrement.prop("disabled", disabled || readonly);
        if (disabled || readonly) {
          resetTimer();
        }
        var originalClass = $original.prop("class");
        var groupClass = "";
        // sizing
        if (/form-control-sm/g.test(originalClass)) {
          groupClass = "input-group-sm";
        } else if (/form-control-lg/g.test(originalClass)) {
          groupClass = "input-group-lg";
        }
        var inputClass = originalClass.replace(/form-control(-(sm|lg))?/g, "");
        $inputGroup.prop(
          "class",
          "input-group " + groupClass + " " + props.groupClass
        );
        $input.prop("class", "form-control " + inputClass);

        // update the main attributes
        min =
          isNaN($original.prop("min")) || $original.prop("min") === ""
            ? -Infinity
            : parseFloat($original.prop("min"));
        max =
          isNaN($original.prop("max")) || $original.prop("max") === ""
            ? Infinity
            : parseFloat($original.prop("max"));
        step = parseFloat($original.prop("step")) || 1;
        if ($original.attr("hidden")) {
          $inputGroup.attr("hidden", $original.attr("hidden"));
        } else {
          $inputGroup.removeAttr("hidden");
        }
        if ($original.attr("id")) {
          $input.attr("id", $original.attr("id") + "_MP_cBdLN29i2");
          if ($label[0]) {
            $label.attr("for", $input.attr("id"));
          }
        }
      }
    });

    return this;
  };

  function onPointerUp(element, callback) {
    element.addEventListener("mouseup", function (e) {
      callback(e);
    });
    element.addEventListener("touchend", function (e) {
      callback(e);
    });
    element.addEventListener("keyup", function (e) {
      if (e.keyCode === 32 || e.keyCode === 13) {
        triggerKeyPressed = false;
        callback(e);
      }
    });
  }

  function onPointerDown(element, callback) {
    element.addEventListener("mousedown", function (e) {
      if (e.button === 0) {
        e.preventDefault();
        callback(e);
      }
    });
    element.addEventListener("touchstart", function (e) {
      if (e.cancelable) {
        e.preventDefault();
      }
      callback(e);
    });
    element.addEventListener("keydown", function (e) {
      if ((e.keyCode === 32 || e.keyCode === 13) && !triggerKeyPressed) {
        triggerKeyPressed = true;
        callback(e);
      }
    });
  }
})(jQuery);

/*=====custom-editors.js=====*/

/**
 * Author and copyright: Stefan Haack (https://shaack.com)
 * Repository: https://github.com/shaack/bootstrap-input-spinner
 * License: MIT, see file 'LICENSE'
 */

var customEditors = {
  RawEditor: function (props, element) {
    this.parse = function (customFormat) {
      // parse nothing
      return customFormat;
    };
    this.render = function (number) {
      // render raw
      return number;
    };
  },
  TimeEditor: function (props, element) {
    // could be implemented more elegant maybe, but works
    this.parse = function (customFormat) {
      var trimmed = customFormat.trim();
      var sign = 1;
      if (trimmed.charAt(0) === "-") {
        sign = -1;
        trimmed = trimmed.replace("-", "");
      }
      var parts = trimmed.split(":");
      var hours = 0,
        minutes;
      if (parts[1]) {
        hours = parseInt(parts[0], 10);
        minutes = parseInt(parts[1], 10);
      } else {
        minutes = parseInt(parts[0], 10);
      }
      return (hours * 60 + minutes) * sign;
    };
    this.render = function (number) {
      var minutes = Math.abs(number % 60);
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      var hours;
      if (number >= 0) {
        hours = Math.floor(number / 60);
        return hours + ":" + minutes;
      } else {
        hours = Math.ceil(number / 60);
        return "-" + Math.abs(hours) + ":" + minutes;
      }
    };
  },
};

/*=========================
	#Global Javascript
=========================*/

/*=====Bootstrap Input Spinner Implementation=====*/

$("input[type='number']").inputSpinner();

/*==========================
	#Bootstrap Tooltips
==========================*/
const tooltips = document.querySelectorAll("bootstrap-tooltip");
tooltips.forEach((t) => {
  new bootstrap.Tooltip(t);
});

/*================
	#LazyLoad
================*/
var lazyLoadInstance = new LazyLoad({
  // Your custom settings go here
});

/*===========================
	#Hamburger Menu Icon
===========================*/
const menuBtn = document.querySelector(".navbar-toggler-icon");
let menuOpen = false;
menuBtn.addEventListener("click", () => {
  if (!menuOpen) {
    menuBtn.classList.add("open");
    menuOpen = true;
  } else {
    menuBtn.classList.remove("open");
    menuOpen = false;
  }
});

/*=======================
	#Site Navigation
=======================*/
// MOBILE ADJUSTMENTS

// OPEN MOBILE NAVIGATION
$(".site-navigation-body__hamburger").on("click", function () {
  $(".body-blackout").removeClass("hidden");
  $(".site-navigation-body__menu").addClass("show");
  $("body").addClass("locked");
});

// CLOSE WHEN CLICKING X
$(".site-navigation-body__close").on("click", function () {
  $(".body-blackout").addClass("hidden");
  $(".site-navigation-body__menu").removeClass("show");
  $("body").removeClass("locked");
});

// CLOSE ON CLICK OF BLACKOUT AREA
$("body").on("click", ".body-blackout", function () {
  $(".body-blackout").addClass("hidden");
  $(".site-navigation-body__menu").removeClass("show");
  $("#navbarNav").removeClass("show");
  $("body").removeClass("locked");
});

// CLOSE MOBILE MENU ON HITTING ESCAPE
$(document).keyup(function (e) {
  if (e.keyCode == 27) {
    // escape key maps to keycode `27`
    $(".body-blackout").addClass("hidden");
    $(".site-navigation-body__menu").removeClass("show");
    $("#navbarNav").removeClass("show");
    $("body").removeClass("locked");
  }
});

/*========================
	#LAYOUT 2 SPECIFIC
========================*/

// SEARCH FUNCTIONALITY

$(".site-navigation-body__icons--search").on("click", function () {
  $(".slideout-search-bar").toggleClass("show");
});

$(".site-navigation-body__icons--search").keypress(function(event) {
   if (event.which == 13) {
    $(".slideout-search-bar").toggleClass("show");  
   }       
});


$(".search-button").focus(function(){
  $(".slideout-search-bar").toggleClass("show");  
});

$(".search-input").focusout(function(){
  $(".slideout-search-bar").removeClass("show");  
});

/*=======================
	#Cart Drawer
=======================*/

var openCart = function () {
  $(".cart-drawer-body").addClass("open");
  $(".body-blackout").removeClass("hidden");
  $("body").addClass("locked");
};
var closeCart = function () {
  $(".body-blackout").addClass("hidden");
  $(".cart-drawer-body").removeClass("open");
  $("body").removeClass("locked");
};

var trashCan =
  '<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M9 3h6v-1.75c0-.066-.026-.13-.073-.177-.047-.047-.111-.073-.177-.073h-5.5c-.066 0-.13.026-.177.073-.047.047-.073.111-.073.177v1.75zm11 1h-16v18c0 .552.448 1 1 1h14c.552 0 1-.448 1-1v-18zm-10 3.5c0-.276-.224-.5-.5-.5s-.5.224-.5.5v12c0 .276.224.5.5.5s.5-.224.5-.5v-12zm5 0c0-.276-.224-.5-.5-.5s-.5.224-.5.5v12c0 .276.224.5.5.5s.5-.224.5-.5v-12zm8-4.5v1h-2v18c0 1.105-.895 2-2 2h-14c-1.105 0-2-.895-2-2v-18h-2v-1h7v-2c0-.552.448-1 1-1h6c.552 0 1 .448 1 1v2h7z"/></svg>';
var emptyCartMessage = $(".cart-drawer-body__body").data("empty-cart-title");

// Main function that updates the cart drawer
var updateCartDrawer = function (event) {
  $.ajax({
    type: "get",
    url: window.Shopify.routes.root + "cart.js",
    dataType: "json",
    success: function (response) {
      // Parse cart response into json
      var cart = response;

      // Set Cart Qty in icon
      var cartCount = cart.item_count;
      //desktop
      $(".announcement-bar-body__icons--cart-count").html(cartCount);
      //mobile
      $(".site-navigation-body__icons--cart-count").html(cartCount);

      var cartItems = [];
      // Add HTML of each item to the cart
      $(cart.items).each(function () {
        var optName = this.options_with_values;
        var itemProperties = this.properties;
        var optionName = "";
        const sizeTag = '_75x';
        const cartItemImg = this.image.replace(/(\.[^./?#]+)($|[?#])/, `${sizeTag}$1$2`);

        $(optName).each(function (index, item) {
          if (item.value.indexOf("Default") < 0) {
            optionName +=
              '<li class="">' + item.name + ": " + item.value + "</li>";
          }
        });

        for (const [key, value] of Object.entries(itemProperties)) {
          if (key && value && !key.startsWith("_")) {
            optionName += `<li class="CartItem__Property"><span class="fw-bold">${key}</span>: ${value}</li>`;
          }
        }
        
        // optionName += '<li class="">Device: '+this.product_type+'</li>'

        var vTitle = this.variant_title;

        if (vTitle == null) {
          vTitle = "";
        }

        var item =
          '<div class="cart_item col-12 mt-3 mb-1 border-bottom pb-3" data-var-id="' +
          this.variant_id +
          '">';
        item += '<div class="row">';
        item +='<div class="cart_item__image col-3"><img src="' +cartItemImg +'" alt="' + this.product_title +'"></div>';
        item += '<div class="cart_item__title col-7">';
        item +='<div class="h-100 d-flex flex-column align-items-start justify-content-between"><div class="cart_item__title--product">' + this.product_title +"</div><ul class='cart_item__title--variant'>"+optionName+"</ul>";
        item +='<div class="cart_item__input"><input class="form-control-sm" type="number" value="' +this.quantity +'"></div></div>';
        item += "</div>";
        item +='<div class="cart_item__delete delete col-2"><div class="h-100 d-flex flex-column align-items-end justify-content-between">' +trashCan +'<div class="cart_item__price mt-2 fw-bold text-end">' +Shopify.formatMoney(this.price) +"</div></div>";
        item += "</div>";
        item += "</div>";
        cartItems.push(item);
        // $('.cart-drawer-body__body').append(item);
      });

      // Clear cart items HTML
      $(".cart-drawer-body__body .cart-item-wrapper").empty();

      for (let cartItem of cartItems) {
        $(".cart-drawer-body__body .cart-item-wrapper").append(cartItem);
      }

      // reinstantiate input spinner
      $("input[type='number']").inputSpinner();

      $(".cart-drawer-body__footer--subtotal--subtotal").html(
        "" + Shopify.formatMoney(cart.items_subtotal_price)
      );

      if (cartItems.length > 0) {
        $(".empty-cart-wrapper").addClass("d-none");
        $(".cart-drawer-body__footer").removeClass("d-none");
        $(".cart-drawer-body__body .cart-item-wrapper").removeClass("d-none");
      } else {
        $(".empty-cart-wrapper").removeClass("d-none");
        $(".cart-drawer-body__footer").addClass("d-none");
        $(".cart-drawer-body__body .cart-item-wrapper").addClass("d-none");
      }

      $("#cart-overlay").fadeOut();
      // Display cart
      openCart();
    },
    error: function (err) {
      console.log(err);
    },
  });
};

// OPEN CART DRAWER
$(".open-cart-drawer").on("click", function () {
  openCart();
});

$(".open-cart-drawer").keypress(function(event) {
   if (event.which == 13) {
   openCart();    
   }       
});



// CLOSE WHEN CLICKING X
$(".cart-drawer-hamburger").on("click", function () {
  closeCart();
});

// CLOSE ON CLICK OF BLACKOUT AREA
$("body").on("click", ".body-blackout", function () {
  closeCart();
});

// CLOSE MOBILE MENU ON HITTING ESCAPE
$(document).keyup(function (e) {
  if (e.keyCode == 27) {
    // escape key maps to keycode `27`
    closeCart();
  }
});

// update cart when qty is changed
$(".cart-drawer-body__body").on("change", "input", function () {
  var qty = $(this).val() < 0 ? 0 : $(this).val();
  var id = $(this).closest(".cart_item").data("var-id");
  var data = {};
  data.updates = {};
  data.updates[id] = qty;
  $("#cart-overlay").show();
  $.ajax({
    type: "post",
    url: window.Shopify.routes.root + "cart/update.js",
    data: data,
    dataType: "json",
    success: function (response) {
      $("body").trigger("requestCartUpdate");
    },
    error: function (err) {
      $("#cart-overlay").fadeOut();
    },
  });
});

// update cart when line is removed
$(".cart-drawer-body__body").on("click", ".delete", function () {
  var id = $(this).closest(".cart_item").data("var-id");
  var data = {};
  data.updates = {};
  data.updates[id] = 0;

  $.ajax({
    type: "post",
    url: window.Shopify.routes.root + "cart/update.js",
    data: data,
    dataType: "json",
    success: function (response) {
      $("body").trigger("requestCartUpdate");
    },
    error: function (err) {},
  });
});

// Listen for Cart Update event
$("body").on("requestCartUpdate", updateCartDrawer);

/*============
	#Hero
============*/

/*==============
	#Footer
==============*/
$(".footer-body__menu--title-wrapper").on("click", function () {
  let connection = $(this).data("mobile-menu");

  $(".footer-body__menu--linklist." + connection).toggleClass("show");
  $(".menu-control-caret." + connection).toggleClass("show");
});

/*===== Back To Top Button =====*/

// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function () {
  scrollFunction();
};

function scrollFunction() {
  const mybutton = document.getElementById("back-to-top-button");
  if (mybutton) {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      mybutton.style.display = "block";
    } else {
      mybutton.style.display = "none";
    }
  }
}

// When the user clicks on the button, scroll to the top of the document
function topFunction() {
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}

/*=========================
	#Product Page
=========================*/
if (document.getElementById("AddToCartErr")) {
  var modal = new bootstrap.Modal(document.getElementById("AddToCartErr"));
}

/*=====VARIANT SELECTED INDICATOR*/
$(".variant-picker-body__swatch--input").on("click", function () {
  $(".variant-picker-body__swatch--input").removeClass("checked");
  $(this).addClass("checked");
});

/*=====PRODUCT TABS JS=====*/
$(".product-template__tabs--tab").on("click", function () {
  let tab = $(this).data("tab-title");
  $(".product-template__tabs--tab").removeClass("active");
  $(this).addClass("active");

  $(".product-template__tab-content--content").removeClass("active");
  $(".product-template__tab-content--content." + tab).addClass("active");
});

// tos return policy modal on add to cart
let tosModal;
if (document.getElementById('tos-return-policy-modal')) {
  tosModal = new bootstrap.Modal(document.getElementById('tos-return-policy-modal'));  
}

/*==========Add To Cart ====================*/
$("form[action='/cart/add']").on("submit", function (e) {
  e.preventDefault();
  tosModal.show();  
});
if (document.querySelector('#regular-confirm-button')) {
  document.querySelector('#regular-confirm-button').addEventListener('click', (e) => {
    e.preventDefault();
    addRegularProductToCart();
  });
}

function addRegularProductToCart() {
  tosModal.hide();
  var form = $('form[action$="/cart/add"]').serialize();
  $("#cart-overlay").show();
  // AJAX Add To Cart
  $.ajax({
    type: "POST",
    url: window.Shopify.routes.root + "cart/add.js",
    data: form,
    dataType: "json",
    success: function (response) {
      $("body").trigger("requestCartUpdate");
    },
    error: function (err) {
      var response = JSON.parse(err.responseText);
      $("#AddToCartErr .modal-title").html(response.message);
      $("#AddToCartErr .modal-body").html(response.description);
      $("#cart-overlay").fadeOut();
      modal.show();
    },
  });
}

/*========== NEW PDP Add To Cart ====================*/
if (document.querySelector('#confirm-check')) {
  document.querySelector('#confirm-check').addEventListener('change', (e) => {
    if (e.target.checked) {
      document.querySelector('.confirm-button').classList.remove('disabled');
    } else {
      document.querySelector('.confirm-button').classList.add('disabled');
    }
  });
}
if (document.querySelector('#child-add-to-cart')) {        
  document.querySelector('#child-add-to-cart').addEventListener('click', (e) => {
    e.preventDefault();
    const filteredProduct = (window.filteredChildProducts.length === 1) ? window.filteredChildProducts[0] : null;
    if (!filteredProduct) {
      return;
    }
    // addFilteredProductToCart(filteredProduct);    
    tosModal.show();
  });
}
if (document.querySelector('#child-confirm-button')) {
  document.querySelector('#child-confirm-button').addEventListener('click', (e) => {
    e.preventDefault();
    const filteredProduct = (window.filteredChildProducts.length === 1) ? window.filteredChildProducts[0] : null;
    if (!filteredProduct) {
      return;
    }
    addFilteredProductToCart(filteredProduct);
  });
}

function addPropertiesFromSelections() {
  const productOptionColumnsSelected = document.querySelectorAll('.product-option-column.selected');
  let selectedProductProperties = {};
  for (const column of productOptionColumnsSelected) {
    const optionName = column.getAttribute('data-option');
    const optionValue = column.querySelector('.display-attribute-value')?.textContent;
    console.log(optionName, optionValue);
    if (optionName && optionValue) {
      selectedProductProperties[optionName] = optionValue;
    }
  }
  console.log(selectedProductProperties);

  return selectedProductProperties;
}

function addFilteredProductToCart(filteredProduct) {
  tosModal.hide();
  $("#cart-overlay").show();

    let formData = {
      'items': [{
      'id': filteredProduct.variant_id,
      'quantity': 1,
      'properties': addPropertiesFromSelections()
      }]
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      console.log('atc response', response)
      if (!response.ok) {
        const error = new Error('Failed to add product to cart');
        error.description = response.statusText;
        throw error;
      }
      return response.json();
    })
    .then(() => {
      document.body.dispatchEvent(new CustomEvent('requestCartUpdate'));
    })
    .catch((error) => {
      console.error('Error:', error);
      // Handle error
      $("#AddToCartErr .modal-title").html(error.message);
      $("#AddToCartErr .modal-body").html(error.description);
      $("#cart-overlay").fadeOut();
      modal.show();
    });
}


/*==========Variant Selection Code==========*/

// SWATCHES

jQuery(function () {
  jQuery(".swatch :radio").change(function () {
    var optionIndex = jQuery(this).closest(".swatch").attr("data-option-index");
    var optionValue = jQuery(this).val();
    jQuery(this)
      .closest("form")
      .find(".single-option-selector")
      .eq(optionIndex)
      .val(optionValue)
      .trigger("change");
  });
});

/*=======================
	#Select Callback
=======================*/

var selectCallback = function (variant, selector) {
  //   VARIABLES
  var costcoPrice = Shopify.formatMoney(variant.price);
  var regularPrice = Shopify.formatMoney(variant.compare_at_price);

  // PRODUCT PAGE CHANGES
  $(".product-template__body--price .costco-price span").html(costcoPrice);
  $(".product-template__body--price .regular-price span").html(regularPrice);

  //   PRODUCT IMAGE SLIDER FILTERING

  $(".product-image-slider__body").slick("slickUnfilter");
  $(".product-image-slider__thumbnails").slick("slickUnfilter");

  $(".slick-filter-image").removeClass("filter");

  if (variant) {
    var filterIndexes = [];
    $(".swatch").each(function (index, item) {
      var optionName = $(item).data("option-name").toLowerCase();
      if (optionName == "size" || optionName == "color" || optionName == "finish" || optionName == "Finish" || optionName == "Experience" || optionName == "experience") {
        filterIndexes.push(index + 1);
        if (optionName == "color" || optionName == "finish") {
          var color = variant["option" + (index + 1)];
          if ($(".shown-in").length > 0) {
            $(".shown-in").html(
              '<span class="shown-in fw-bold pe-2">Shown In ' +
                color +
                "</span>"
            );
          } else {
            $(".variant-picker-body__swatch").prepend(
              '<span class="shown-in fw-bold pe-2">Shown In ' +
                color +
                "</span>"
            );
          }
        }
      }
    });
    var fileName = "";

    if (filterIndexes.length > 0) {
      $(filterIndexes).each(function (index, item) {
        var option = "option" + item;
        if (index != 0) {
          fileName += "-";
        }
        fileName += variant[option].replace(/\s/g, "-").replaceAll(".", "-").replace(/["']/g, "");
      });
    }

    fileName = fileName.toLowerCase();

    $(".slick-filter-image").each(function () {
      var dataFile = $(this).data("file-name");
      console.log('DataFile '+dataFile)
      console.log('FileName '+fileName)
      console.log(dataFile.indexOf(fileName))
      if (dataFile.indexOf(fileName) > -1) {
        $(this).addClass("filter");
      }
    });

    if ($(".filter").length > 0) {
      console.log("have Filter");
      $(".product-image-slider__body").slick("slickFilter", ".filter");
      $(".product-image-slider__thumbnails").slick("slickFilter", ".filter");

      // re index thumbnail slides
      $(".product-image-slider__thumbnails .slick-slide").each(function (
        index
      ) {
        $(this).attr("data-slick-index", index);
      });
      // re index main slides
      $(".product-image-slider__body .slick-slide").each(function (index) {
        $(this).attr("data-slick-index", index);
      });
      $(".product-image-slider__thumbnails").slick("slickGoTo", 0);

      if ($(".product-image-slider__thumbnails .slick-track").length < 6) {
        $(".product-image-slider__thumbnails .slick-track")
          .css("transform", "none !important")
          .css("width", "100% !important")
          .css("margin", "0 !important;");
      }
    }
  } //   END IF VARIANT

  //  UPDATE VARIANT SPECIFIC CONTENT

  function decodeEntity(inputStr) {
    var textarea = document.createElement("textarea");
    textarea.innerHTML = inputStr;
    return textarea.value;
  }
  if (Object.keys(vmeta[variant.id]).length > 0) {
    for (let i = 1; i < 5; i++) {
      var tabs = Array.from(vmeta[variant.id]);

      $(".product-template__tab-content--content.tab" + i).html(
        decodeEntity(vmeta[variant.id]["tab" + i])
      );
    }
  }
}; // END OF SELECT CALLBACK

/*================
	#FAQ PAGE
================*/

$(".faq-page__question--title").on("click", function () {
  $(this).toggleClass("active");
  $(this).siblings().closest(".faq-page__answer").toggleClass("active");
});

/*===============================
	#Product Recommendations
===============================*/

const handleIntersection = (entries, observer) => {
  if (!entries[0].isIntersecting) return;

  const productRecommendationsSection = document.querySelector(
    ".product-recommendations"
  );
  observer.unobserve(productRecommendationsSection);

  const url = productRecommendationsSection.dataset.url;

  fetch(url)
    .then((response) => response.text())
    .then((text) => {
      const html = document.createElement("div");
      html.innerHTML = text;
      const recommendations = html.querySelector(".product-recommendations");

      if (recommendations && recommendations.innerHTML.trim().length) {
        productRecommendationsSection.innerHTML = recommendations.innerHTML;
      }
      $(".product-recommendations-slider").slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              arrows: true,
            },
          },
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              arrows: true,
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              arrows: false,
              centerMode: true,
              dots: true,
            },
          },
        ],
      });
    })
    .catch((e) => {
      console.error(e);
    });
};
if ($(".product-recommendations").length > 0) {
  const productRecommendationsSection = document.querySelector(
    ".product-recommendations"
  );
  const observer = new IntersectionObserver(handleIntersection, {
    rootMargin: "0px 0px 200px 0px",
  });

  observer.observe(productRecommendationsSection);
}


/*===============================
	#Recommended Accessories
===============================*/

    $(".recommended-accessories-slider").slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              arrows: true,
            },
          },
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              arrows: true,
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              arrows: false,
              centerMode: true,
              dots: true,
            },
          },
        ],
      });

      $(".required-accessories-slider").slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              arrows: true,
            },
          },
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              arrows: true,
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              arrows: false,
              centerMode: true,
              dots: true,
            },
          },
        ],
      });
/*====================================
	#Variant Out Of Stock Manager
====================================*/

var Shopify = Shopify || {};

Shopify.optionsMap = {};

Shopify.updateOptionsInSelector = function (selectorIndex) {
  switch (selectorIndex) {
    case 0:
      var key = "root";
      var selector = jQuery(".swatch:eq(0) :checked");
      break;
    case 1:
      var key = jQuery(".swatch:eq(0) input:checked").val();

      var selector = jQuery(".swatch:eq(1) :checked");
      break;
    case 2:
      var key = jQuery(".swatch:eq(0) :checked").val();
      key += " / " + jQuery(".swatch:eq(1) :checked").val();
      var selector = jQuery(".swatch:eq(2) :checked");
  }
  var initialValue = selector.val();

  var availableOptions = Shopify.optionsMap[key];
  jQuery('.swatch[data-option-index="' + selectorIndex + '"] input').each(
    function () {
      if (jQuery.inArray($(this).val(), availableOptions) !== -1) {
        $(this)
          .removeClass("soldout")
          .removeAttr("disabled", "disabled")
          .removeAttr("checked");
      } else {
        $(this)
          .addClass("soldout")
          .removeAttr("checked")
          .attr("disabled", "disabled");
      }
    }
  );
  if (jQuery.inArray(initialValue, availableOptions) !== -1) {
    selector.attr("checked");
  }
};

Shopify.linkOptionSelectors = function (product) {
  // Building our mapping object.
  for (var i = 0; i < product.variants.length; i++) {
    var variant = product.variants[i];
    if (variant.available) {
      // Gathering values for the 1st drop-down.
      Shopify.optionsMap["root"] = Shopify.optionsMap["root"] || [];
      Shopify.optionsMap["root"].push(variant.option1);
      Shopify.optionsMap["root"] = Shopify.uniq(Shopify.optionsMap["root"]);
      // Gathering values for the 2nd drop-down.
      if (product.options.length > 1) {
        var key = variant.option1;
        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
        Shopify.optionsMap[key].push(variant.option2);
        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
      }
      // Gathering values for the 3rd drop-down.
      if (product.options.length === 3) {
        var key = variant.option1 + " / " + variant.option2;
        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
        Shopify.optionsMap[key].push(variant.option3);
        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
      }
    }
  }
  // Update options right away.
  Shopify.updateOptionsInSelector(0);
  jQuery('[data-option-index="0"] input:first-of-type').click();
  if (product.options.length > 1)   { Shopify.updateOptionsInSelector(1); jQuery('[data-option-index="1"] input:first-of-type').click();};
  if (product.options.length === 3) { Shopify.updateOptionsInSelector(2); jQuery('[data-option-index="2"] input:first-of-type').click();};

  // When there is an update in the first dropdown.
  jQuery(".swatch:eq(0)").change(function () {
    Shopify.updateOptionsInSelector(1);
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
    return true;
  });

  // When there is an update in the second dropdown.
  jQuery(".swatch:eq(1)").change(function () {
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
    return true;
  });
};

var $addToCartForm = $('form[action="/cart/add"]');
if (window.MutationObserver && $addToCartForm.length) {
  if (
    typeof observer === "object" &&
    typeof observer.disconnect === "function"
  ) {
    observer.disconnect();
  }
  var config = { childList: true, subtree: true };
  var observer = new MutationObserver(function () {
    Shopify.linkOptionSelectors(productObj);
    observer.disconnect();
  });
  observer.observe($addToCartForm[0], config);
}

/*###############
	#SLIDERS
###############*/

$(document).ready(function () {}); // Document Ready Function End
/*================================
	#Hero Slider
================================*/

$(".hero-body-slidshow").slick({
  dots: true,
});

/*================================
	#Product Item Card Slider
================================*/

$(".product-item-card-slider").slick({
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
      },
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        centerMode: true,
        dots: true,
      },
    },
  ],
});

/*============================
	Announcement Bar Slider
============================*/

$(".announcement-slider").slick({
  dots: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
});

/*============================
	#Product Image Slider
============================*/
// Initialize main slider with dots for mobile
var $mainSlider = $(".product-image-slider__body");
var $thumbSlider = $(".product-image-slider__thumbnails");
var $dotsContainer = $(".product-image-slider__dots");

// Initialize main slider
$mainSlider.on('init', function(event, slick) {
  // Force dots to be created if they don't exist
  if ($('.slick-dots', $dotsContainer).length === 0) {
    var dots = $('<ul class="slick-dots"></ul>');
    var slides = $mainSlider.find('.slick-slide:not(.slick-cloned)');
    
    slides.each(function(index) {
      dots.append('<li><button type="button" data-role="none">' + (index + 1) + '</button></li>');
    });
    
    $dotsContainer.append(dots);
  }
});

$mainSlider.slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  infinite: false,
  fade: true,
  dots: true,
  dotsClass: 'slick-dots',
  appendDots: $dotsContainer,
  asNavFor: ".product-image-slider__thumbnails",
  responsive: [
    {
      breakpoint: 992, // Hide dots on desktop
      settings: {
        dots: false
      }
    }
  ]
});

// Manually trigger the init event if the slider is already initialized
if ($mainSlider.hasClass('slick-initialized')) {
  $mainSlider.slick('slickSetOption', 'dots', true).slick('slickSetOption', 'dots', true);
}

$(".product-image-slider__thumbnails").slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: ".product-image-slider__body",
  dots: false,
  centerMode: false,
  focusOnSelect: true,
  infinite: false,
  arrows: true,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 992, // Hide thumbnails on mobile
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        vertical: false
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
  ],
});


/*=====================
  #Lightbox Slider
=====================*/
  
// $('.zslidertrigger,.slider-zoom-icon').on('click', function () { 
//   var slideIndex = $(this).data('slick-index');
//   $('.zslider-blackout').removeClass('hidden');
//   $('body').addClass('locked');
//   window.scrollTo(0, 0);

//   $('.zoom-image-slider__body').slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: true,
//     infinite:true,
//     speed:0,
//     responsive:[
//       {
//         breakpoint:769,
//         settings:{

//         }
//       }
//     ]
//   });//End of Slider

//   $('.zoom-image-slider__body').slick('slickGoTo', slideIndex);

// });

// $('.close-zoom').on('click', function () { 
//   $('.zslider-blackout').addClass('hidden');
//   $('.zoom-image-slider__body').slick('unslick');
//   $('body').removeClass('locked');
// });
